import React from 'react';
import "../styles/pages/home.scss";
import Header from "../../User/layouts/Header";
import { Accordion, AccordionDetails, AccordionSummary, Typography, Container } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';

const Faqs = () => {
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>FAQ’S</Typography>
            </section>
            <section className='faq'>
                <Container maxWidth="xl">
                    <div className='faq-content'>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                1. What is Tailors4U?
                            </AccordionSummary>
                            <AccordionDetails>
                                Tailors4U is an online tailoring and fashion consultation platform that connects customers with professional designers and tailors. You can book live consultations, share your ideas,
                                upload your measurements, select fabrics, and get your custom outfits delivered to your doorstep.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                2. How does Tailors4U work?
                            </AccordionSummary>
                            <AccordionDetails>
                                You simply sign up, choose your preferred designer or tailor, share your design or reference image, provide your measurements, and confirm your order. Our team will handle the rest — from stitching to doorstep delivery.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                3. Who are the designers on Tailors4U?
                            </AccordionSummary>
                            <AccordionDetails>
                                Our designers are verified professionals with proven experience in fashion design, tailoring, and styling. Each designer’s profile displays their expertise, portfolio, and customer ratings.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                How do I book a live consultation?
                            </AccordionSummary>
                            <AccordionDetails>
                                You can schedule a consultation directly through the Tailors4U app or website
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                Can I share my own designs or reference images?
                            </AccordionSummary>
                            <AccordionDetails>
                                Yes! You can upload design references, sketches, or inspiration images during your order process or consultation. <br />
                                If you have a perfect fit outfit, you can provide the same for measurements.
                                If you don't have a perfect fit outfit, you can take measurements with the guidance of designer over a video call. For this you need one more person to help take measurements
                                You can also book in-person consultation, where our Designer will visit and take measurements personally
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                How can I contact Tailors4U support?
                            </AccordionSummary>
                            <AccordionDetails>
                                You can reach us via WhatsApp chat @ 9063939524 or support@tailors4u.com
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                Do you operate in all cities?
                            </AccordionSummary>
                            <AccordionDetails>
                                Currently we serve in Hyderabad only, we are working on expanding to other cities
                            </AccordionDetails>
                        </Accordion>

                        <Accordion >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                What if the outfit doesn’t fit me perfectly?
                            </AccordionSummary>
                            <AccordionDetails>
                                We offer a free alteration service within 3 days from  date of delivery. You can raise an alteration request through the app and website.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                Do you offer doorstep delivery?
                            </AccordionSummary>
                            <AccordionDetails>
                                Yes, we offer free doorstep delivery across hyderabad city.
                            </AccordionDetails>
                        </Accordion>
                        <Accordion >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                Can I get fabric suggestions from the designer?
                            </AccordionSummary>
                            <AccordionDetails>
                                Absolutely! During your consultation, your designer can recommend the best fabrics based on your design and budget.
                            </AccordionDetails>
                        </Accordion>


                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                Do you operate in all cities?
                            </AccordionSummary>
                            <AccordionDetails>
                                Currently we serve in Hyderabad only, we are working on expanding to other cities
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Faqs